import type { ReactElement } from 'react';
import { matchRoutes, type RouteObject } from 'react-router-dom';

/**
 * Start downloading a page before it is rendered — see `lazyPage`.
 *
 * App.tsx registers its route table here once, so anything that knows a path
 * (the sidebar, say) can warm that page without importing App.tsx, which would
 * be an import cycle: App → AppLayout → AppShell → Sidebar → App.
 */

let routes: RouteObject[] = [];

export function registerRoutes(table: RouteObject[]): void {
  routes = table;
}

/**
 * Preload whatever page would render at `path` (a pathname, optionally with a
 * query string). Never throws: preloading is an optimisation, and a path that
 * matches nothing preloadable does nothing.
 */
export function preloadRoute(path: string): void {
  try {
    const pathname = path.split(/[?#]/)[0] || '/';
    for (const match of matchRoutes(routes, pathname) ?? []) {
      const element = match.route.element as ReactElement | null | undefined;
      const component = element?.type as { preload?: () => void } | undefined;
      component?.preload?.();
    }
  } catch {
    /* an optimisation only */
  }
}
